<template>
    <b-modal id="modal-kemasan" title="Tambah Kemasan" variant="success" ref="modalKemasan" hide-footer no-close-on-backdrop no-close-on-esc>
        <div class="row">
            <div class="col-md-6">
                <b-form-fieldset label="Jumlah Kemasan">
                    <input v-validate="'required'" name="Jumlah Kemasan" type="number" class="form-control" v-model="kemasan.jumlahKemasan">
                    <div v-show="errors.has('Jumlah Kemasan')" class="text-danger">{{ errors.first('Jumlah Kemasan') }}</div>
                    <small>Isikan Jumlah Total Kemasan</small>
                </b-form-fieldset>
            </div>
            <div class="col-md-6">
                <b-form-fieldset label="Jenis Kemasan">
                    <model-list-select name="Jenis Kemasan" v-validate="'required'" class="form-control" :list="JenisKemasan" option-value="JNS_KMS"
                    :custom-text="(item) => `${item.JNS_KMS} - ${item.UR_KMS}`" placeholder="Jenis Kemasan" v-model="kemasan.jenisKemasan"></model-list-select>
                    <div v-show="errors.has('Jenis Kemasan')" class="text-danger">{{ errors.first('Jenis Kemasan') }} </div>
                  </b-form-fieldset>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <button @click="submitKemasan()" class="btn btn-success pull-right"><i class="fa fa-plus"></i> Tambah</button>
            </div>
        </div>
    </b-modal>
</template>
<script>
import swal from 'sweetalert'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      JenisKemasan: [],
      kemasan: {
        jumlahKemasan: '',
        jenisKemasan: ''
      }
    }
  },
  created () {
    this.getJenisKemasan()
  },
  methods: {
    ...mapActions({
      setKemasan: 'barpin/setKemasan'
    }),
    getJenisKemasan () {
      this.$http.get('ref/jnskemasan').then((response) => {
        this.JenisKemasan = response.data
      })
    },
    submitKemasan () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('barpin/SET_LOADING_MODAL', true)
          this.setKemasan({...this.kemasan, id_aju: this.$store.state.barpin.header.id_aju}).then(() => {
            this.$refs['modalKemasan'].hide()
            this.$store.commit('barpin/SET_LOADING_MODAL', false)
          }).catch((error) => {
            swal('error', JSON.stringify(JSON.parse(error.bodyText).errors), 'error')
            this.$store.commit('barpin/SET_LOADING_MODAL', false)
          })
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/ppftz/modal/ModalKemasan.vue?524a7b40